import * as table from './TableData';
import { CurrentTime, currentDate_dmy } from "../../../components/Common/CommonFunction";

// 🟢 Draw border on all sides
export const pageBorder = (doc) => {
  doc.setDrawColor('black');
  doc.line(565, 17, 30, 17);   // Top
  doc.line(30, 400, 30, 17);   // Left
  doc.line(565, 400, 565, 17); // Right
  doc.line(565, 400, 30, 400); // Bottom
};

// 🟢 Title/Header
export const pageHeder = (doc, data, mode) => {
  doc.addFont("Arial", "Normal");
  doc.setFont("Arial");

  let title = "";
  let fontSize = 14;
  let fontStyle = "bold";
  let xPos = 190;
  let yPos = 45;

  switch (mode) {
    case 1:
      title = "Loyalty Points Redemption Claim";
      fontSize = 16;
      break;

    case 2:
      title = "Loyalty Points Redemption Claim CBM Summary Report";
      fontSize = 16;
      break;

    case 3:
      title = "Loyalty Coupon Claim";
      fontSize = 16;
      break;

    default:
      title = "Loyalty Report";
      fontSize = 14;
  }

  // 🖋 Apply styles dynamically
  doc.setFontSize(fontSize);
  doc.setFont(undefined, fontStyle);

  // 🧭 Center align title on page
  const pageWidth = doc.internal.pageSize.getWidth();
  const textWidth = doc.getTextWidth(title);
  const centerX = (pageWidth - textWidth) / 2;

  doc.text(title, centerX, yPos);
};

// 🟢 Report Header
export const reportHeder1 = (doc, data, mode) => {
  doc.setFont('Tahoma');
  doc.setFontSize(9);
  doc.setFont(undefined, 'bold');

  // safe destructuring
  const { headerRows } = table.getTableConfig(mode, data);

  const options3 = {
    margin: { top: 0, left: 30, right: 30 },
    theme: 'grid',
    styles: { overflow: 'linebreak', fontSize: 7, fillColor: [255, 255, 255] },
    bodyStyles: {
      textColor: [30, 30, 30],
      cellPadding: 2,
      fontSize: 8,
      lineColor: [0, 0, 0],
    },
    columnStyles: {
      0: { valign: "top", columnWidth: 535, halign: 'left' },
    },
    tableLineColor: "black",
    startY: 55,
  };

  // this is now safe — PageHeaderColumns is defined below in TableData.js
  if (table.PageHeaderColumns) {
    doc.autoTable(table.PageHeaderColumns, headerRows, options3);
  }
};

// 🟢 Table Body (main difference per mode)
export const tableBody = (doc, data, mode) => {
  const { columns, rows } = table.getTableConfig(mode, data);

  let columnStyles = {};

  if (mode === 1) {
    columnStyles = {
      0: { columnWidth: 160, halign: 'left' },
      1: { columnWidth: 120, halign: 'center' },
      2: { columnWidth: 120, halign: 'center' },
      3: { columnWidth: 135, halign: 'right' },
    };
  } else if (mode === 2) {
    columnStyles = {
      0: { columnWidth: 200, halign: 'left' },
      1: { columnWidth: 155, halign: 'right' },
      2: { columnWidth: 180, halign: 'right' },
    };
  } else if (mode === 3) {
    columnStyles = {
      0: { columnWidth: 170, halign: 'left' },
      1: { columnWidth: 170, halign: 'left' },
      2: { columnWidth: 75, halign: 'right' },
      3: { columnWidth: 120, halign: 'right' },
     // 4: { columnWidth: 95, halign: 'right' },
    };
  }

  const options = {
    margin: { left: 30, right: 30, top: 75, bottom: 15 },
    theme: 'grid',
    headStyles: {
      cellPadding: 3,
      lineWidth: 0.8,
      valign: 'middle',
      fontStyle: 'bold',
      halign: 'center',
      fillColor: "white",
      textColor: [0, 0, 0],
      fontSize: 8,
      lineColor: [0, 0, 0],
    },
    bodyStyles: {
      textColor: [30, 30, 30],
      cellPadding: 2,
      fontSize: 8,
      columnWidth: 'wrap',
      lineColor: [0, 0, 0],
    },
    columnStyles,
    tableLineColor: "black",
    startY: doc.autoTableEndPosY() || 70,
  };

  doc.autoTable(columns, rows, options);
};

// 🟢 Footer
export const pageFooter = (doc, data, mode) => {
  const pageCount = doc.internal.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    pageHeder(doc, data, mode);
    pageBorder(doc);

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const leftMargin = 30;
    const rightMargin = 30;
    const bottomMargin = 10;
    const footerY = pageHeight - bottomMargin;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    // ✅ Left Side: Print Date
    doc.text(`Print Date: ${currentDate_dmy}  Time: ${CurrentTime()}`,leftMargin,footerY);
    // ✅ Right Side: Page Number
    doc.text(`Page ${i} of ${pageCount}`,pageWidth - rightMargin - doc.getTextWidth(`Page ${i} of ${pageCount}`),footerY);
  }
};
